import {
  AppDropdownMenu,
  IDropdownMenuItem,
} from "../../../../common/components/AppDropdownMenu";
import styles from "./CommunicationLogsTabHeader.module.scss";

interface ICommunicationLogsTabHeaderProps {
  label: string;
  /** The tab's "⋮" actions (e.g. "Нов имейл"). A tab without any keeps the same height. */
  menuItems?: IDropdownMenuItem[];
}

export const CommunicationLogsTabHeader = ({
  label,
  menuItems,
}: ICommunicationLogsTabHeaderProps) => (
  <span className={styles.root}>
    {label}
    {menuItems && (
      <span onClick={(e) => e.stopPropagation()}>
        <AppDropdownMenu
          items={menuItems}
          triggerIconSize="18px"
          triggerIconColor="#fff"
        />
      </span>
    )}
  </span>
);
